var formatPaymentTerms = require('../utils/format-payment-terms')
var postingSides = require('posting-sides')
var t = require('i18n').t
var ValueResolver = require('../utils/value-resolver')
var NOTIFICATION_KEYS = require('../notificationKeys')
var Scope = require('../utils/scope')

module.exports = Em.ObjectController.extend({
    needs: ['organization'],

    auth: Em.inject.service(),

    segment: Em.inject.service(),

    userOrganizations: Em.inject.service(),

    organization: Em.computed.alias('userOrganizations.activeOrganization'),

    title: function() {
        var title = this.get('name')
        if (this.get('isSupplier')) {
            title += ' (' + t('contacts.supplier') + ')'
        } else if (this.get('isCustomer')) {
            title += ' (' + t('contacts.customer') + ')'
        }
        return title
    }.property('name', 'isCustomer', 'isSupplier'),

    isBothCustomerAndSupplier: function() {
        return (this.get('isCustomer') && this.get('isSupplier'))
    }.property('isCustomer', 'isSupplier'),

    hasNonBlankContactPersons: function() {
        return this.get('contactPersons').any(function(person) {
            return (!Em.isEmpty(person.get('name')) || !Em.isEmpty(person.get('email')))
        })
    }.property('contactPersons.@each.name', 'contactPersons.@each.email'),

    // it is needed, because in Ageras app, customer type is not allowed to create invoices,
    // but only guarding the dropdown item would result in displaying an empty dropdown,
    shouldHideCreateDropdown: function() {
        return !this.get('auth').isAuthorized(Scope.InvoiceWrite) && this.get('isCustomer') && !this.get('isSupplier')
    }.property('isCustomer', 'isSupplier'),

    paymentTermsText: function() {
        return formatPaymentTerms(this.get('paymentTermsMode'), this.get('paymentTermsDays'))
    }.property('paymentTermsMode', 'paymentTermsDays'),

    invoicingLanguageName: function() {
        var invoicingLanguage = this.get('invoicingLanguage')

        if (!invoicingLanguage) {
            return null
        }

        var languageKeyMap = {
            de: 'invoicing_language.german',
            en: 'invoicing_language.english',
            fi: 'invoicing_language.finnish',
            fr: 'invoicing_language.french',
            nl: 'invoicing_language.dutch',
            sv: 'invoicing_language.swedish'
        }
        var key = languageKeyMap[invoicingLanguage]

        return key ? t(key) : invoicingLanguage
    }.property('invoicingLanguage'),

    canDeleteAndArchive: function() {
        return this.get('model.organization.isBrandBilly')
    }.property('model.organization'),

    balances: function() {
        var self = this
        var contact = this.get('model')
        if (!contact) {
            return null
        }
        return ValueResolver.create({
            resolver: function() {
                return new Em.RSVP.Promise(function(resolve, reject) {
                    var api = self.container.lookup('api:billy')
                    api.get('/contacts/' + contact.get('id') + '/balances', {
                        success: function(payload) {
                            var balances = payload.balances
                            balances.forEach(function(b) {
                                b.side = postingSides.resolveSide(b.side)
                            })
                            resolve(balances)
                        },
                        error: reject
                    })
                })
            }
        })
    }.property('model'),

    timelineUrl: function() {
        var contact = this.get('model')
        return '/organizations/' + contact.get('organization.id') + '/contacts/' + contact.get('id') + '/timeline'
    }.property('model{organization,id}'),

    createBillLabel: t('contact.index.create_bill'),

    isCustomerEditModalOpen: false,

    onCustomerEditModalUpdated: function() {
        var self = this
        return function() {
            var contactRoute = self.container.lookup('route:contact')
            if (contactRoute) {
                contactRoute.refresh()
            }
        }
    }.property(),

    isOnCustomerRoute: function() {
        var currentRoute = this.container.lookup('controller:application').get('currentRouteName')
        return currentRoute === 'contact.customer'
    },

    actions: {
        didSelectCategory: Em.K,

        edit: function() {
            if (this.get('isCustomer')) {
                this.get('segment').track('XXX - Invoicing Success - Customer Details - Edit Button Clicked')
            }

            if (this.isOnCustomerRoute() && !this.get('organization.isBrandBilly')) {
                this.set('isCustomerEditModalOpen', true)
                return
            }

            var contactEditor = this.container.lookup('component:contactEditor')
            contactEditor.set('content', this.get('model'))
            contactEditor.set('typesHidden', true)
            contactEditor.show()
        },

        delete: function() {
            var self = this
            var contact = this.get('model')
            var isSupplier = self.get('isSupplier')

            var title = isSupplier ? t('contact.index.delete_supplier_title') : t('contact.index.delete_title')
            var description = isSupplier ? t('contact.index.delete_supplier_question') : t('contact.index.delete_question')

            this.container.lookup('util:dialog').confirmWarning(title, description, t('yes_delete'))
                .then(function() {
                    contact
                        .deleteRecord()
                        .success(function() {
                            self.get('segment').track('Contact Deleted (Client)', {
                                type: isSupplier ? 'supplier' : 'customer'
                            })

                            self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.CONTACT_DELETE, t('contact.index.was_deleted'))
                            var orgUrl = self.get('userOrganizations.lastOrganizationUrl')
                            if (isSupplier) {
                                self.transitionToRoute('/' + orgUrl + '/suppliers')
                            } else {
                                self.transitionToRoute('/' + orgUrl + '/clients')
                            }
                        })
                        .error(function(errorMessage, payload) {
                            if (payload.errorCode === 'UNDELETABLE_RECORD') {
                                var isBillyOrg = self.get('model.organization.isBrandBilly')
                                // We need to check if the org is billy, because they
                                // do have permission to archive contacts when non-deletable
                                if (isSupplier && !isBillyOrg) {
                                    self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.CONTACT_DELETE, payload.errorMessage || errorMessage, 'error')
                                    return
                                }

                                self.container.lookup('util:dialog').confirmWarning(t('contact.index.archive_title'), t('contact.index.archive_undeletable_question'), t('contact.index.yes_archive'))
                                    .then(function() {
                                        self.send('archive')
                                    })
                            } else {
                                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.CONTACT_DELETE, payload.errorMessage || errorMessage)
                            }
                        })
                })
        },

        archive: function() {
            var self = this
            this.get('model').set('isArchived', true).save()
                .success(function() {
                    self.get('segment').track('Contact Archived (Client)')
                })
                .error(function(errorMessage, payload) {
                    self.get('model').set('isArchived', false)
                    self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.CONTACT_ARCHIVE, payload.errorMessage || errorMessage)
                })
        },

        unarchive: function() {
            this.get('model').set('isArchived', false).save()
        },

        registerPrepayment: function(isSupplier) {
            var self = this

            if (self.get('isCustomer')) {
                self.get('segment').track('XXX - Invoicing Success - Customer Details - More Menu - Ingoing / outgoing payment clicked')
            }

            this.container.lookup('component:contact-prepayment-window')
                .set('callback', function() {
                    self.get('balances').invalidate()
                })
                .showForContact(this.get('model'), isSupplier)
        },

        export: function() {
            if (this.get('isCustomer')) {
                this.get('segment').track('XXX - Invoicing Success - Customer Details - More Menu - Account statement clicked')
            }

            if (!this.get('auth').isAuthorized(Scope.ContactStatementRead)) {
                this.container.lookup('component:upgrade-plan-overlay')
                    .show()
                return
            }

            this.container.lookup('component:contact-export-window')
                .set('contact', this.get('model'))
                .show()
        },

        trackCreateBill: function() {
            this.get('segment').track('xxx - expenses - create purchase click', {
                source: 'Supplier'
            })
        }
    }
})
